export default __webpack_public_path__ + "media/integrations/invision-08ac8f64.svg";